/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewChild, inject } from '@angular/core'
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns'
import { FilterService } from '@progress/kendo-angular-grid'
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query'

import { Enums } from '@cyborg-monorepo/hunter/common'

import { BaseCustomFilterComponent } from './base-custom-filter.component'

@Component({
  standalone: false,
  selector: 'multiselect-tag-filter',
  template: `
    <kendo-multiselect
      #multiselect
      [value]="currentFilterValue"
      [data]="data"
      [field]="field"
      (valueChange)="onChange($event)"
      textField="text"
      valueField="value"
      placeholder="(All)"
    >
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        @if (dataItem.value) {
          <span
            style="color: transparent"
            class="k-icon k-i-kpi-status-open"
            [ngClass]="dataItem.class"
          ></span>
        }
        {{ dataItem.text }}
      </ng-template>
    </kendo-multiselect>
  `,
})
export class MultiselectTagFilterComponent extends BaseCustomFilterComponent {
  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField)
    return filter ? filter.value : null
  }

  @ViewChild('multiselect', { read: MultiSelectComponent })
  public select: MultiSelectComponent

  @Input() public filter: CompositeFilterDescriptor
  @Input() public data: {
    text: string
    value: Enums.StatusEnum | Enums.PriorityEnum | Enums.OutcomeEnum
    class: string
  }[]
  @Input() public field: string
  @Input() public textField: string
  @Input() public valueField: string

  // Constructor needed for proper filter functioning

  constructor() {
    const filterService = inject(FilterService)

    super(filterService)
  }

  public get currentFilterValue(): any {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field }) => {
          return field === this.field
        },
      )
      const result: { text: string; value: string }[] = []
      if (filter && filter.value && filter.value.length) {
        filter.value.forEach((value) => {
          result.push({ text: value, value: value })
        })
      }
      return result
    } else return []
  }

  public resetDefault(): void {
    this.select.reset()
  }

  public onChange(value: any): void {
    const processedValue = value.map((a) => a.value)
    this.applyFilter(
      value === null || processedValue.length == 0 // value of the default item
        ? this.removeFilter(this.field) // remove the filter
        : this.updateFilter({
            // add a filter for the field with the value
            field: this.field,
            operator: 'eq',
            value: processedValue,
          }),
    ) // update the root filter
  }
}
